
	import { Component, Prop, Vue } from 'vue-property-decorator'
    import { VueLoading } from 'vue-loading-template';

    @Component({
        components: { VueLoading }
    })
	export default class BlockUI extends Vue {
		@Prop({ type: Boolean }) private isLoading!: boolean
	}

